__turbopack_context__.v({
  "marker": "FeatureDneMarker-module__Hupyla__marker",
  "tooltipContent": "FeatureDneMarker-module__Hupyla__tooltipContent",
});
